import doisotrung from "../../assets/images/doisotrung.gif";
import veso from "../../assets/images/icons/veso.gif";
import printGif from "../../assets/images/icons/print.gif";
import React from "react";

const LinkBotton = () => {
    return (
        <>
            <div className="bangkqxs_link">
                <table cellSpacing="4">
                    <tbody>
                    <tr>
                        <td nowrap="nowrap">
                            <a href="/">
                                <img alt="dd"
                                     src={doisotrung}
                                /> Đổi số trúng</a>
                        </td>
                        <td nowrap="nowrap"><a href="/"
                                               title="Mẫu vé kiểm tra khi đổi số trúng thưởng">
                            <img alt="" src={veso}/>Mẫu
                            vé kiểm tra</a></td>
                        <td nowrap="nowrap"><a href="/"
                                               title="In vé dò (in bảng kết quả xổ số) Miền Trung ngày 08/06/2021">
                            <img alt="" src={printGif}/>In
                            Vé Dò</a></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="clear"/>
        </>
    );
};
export default LinkBotton;
